import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES } from '@/utils/constants';
import FirstStep from '../FirstStep/FirstStep.vue';
import SecondStep from '../SecondStep/SecondStep.vue';

const STEPS = {
  FIRST: 1,
  SECOND: 2,
};

export default {
  name: 'RegisterForm',
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      step: STEPS.FIRST,
    };
  },
  computed: {
    ...mapState('user', {
      registerForm: ({ registerForm }) => registerForm,
      registering: ({ registering }) => registering,
    }),
    isFirstStep() {
      return this.step === STEPS.FIRST;
    },
    stepAction() {
      const mapping = {
        [STEPS.FIRST]: () => this.next(),
        [STEPS.SECOND]: () => this.register(),
      };
      return mapping[this.step];
    },
    stepComponent() {
      const mapping = {
        [STEPS.FIRST]: FirstStep,
        [STEPS.SECOND]: SecondStep,
      };
      return mapping[this.step];
    },
  },
  beforeDestroy() {
    this.setRegisterForm({});
  },
  mounted() {
    const { step = STEPS.FIRST } = this.$route.query;
    const { account: mail, password: pwd } = this.registerForm;
    if (
      !Number.isInteger(+step)
      || +step > STEPS.SECOND
      || (step !== STEPS.FIRST && !(mail || pwd))
    ) {
      this.step = STEPS.FIRST;
      this.goStep(STEPS.FIRST);
    }
    this.step = +step;
  },
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          const { step = STEPS.FIRST } = newVal;
          this.step = +step;
        }
      },
    },
  },
  methods: {
    ...mapActions('user', {
      setRegisterForm: 'SET_USER_REGISTER_FORM',
      userRegister: 'USER_REGISTER',
    }),
    next() {
      this.step = STEPS.SECOND;
      this.goStep(STEPS.SECOND);
    },
    async register() {
      try {
        await this.userRegister(this.registerForm);
        this.$router.replace({ name: 'RegisterCompleted', params: { email: this.registerForm?.account } });
      } catch (error) {
        const { message = '' } = error;
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          msg: `註冊失敗。${message}`,
        });
      }
    },
    goStep(step = this.step) {
      const path = this.isFirstStep ? '/register' : `/register?step=${step}`;
      this.$router.push(path);
    },
  },
};
